import { render, staticRenderFns } from "./PointHandler.vue?vue&type=template&id=1a90083b&scoped=true"
import script from "./PointHandler.vue?vue&type=script&lang=js"
export * from "./PointHandler.vue?vue&type=script&lang=js"
import style0 from "./PointHandler.vue?vue&type=style&index=0&id=1a90083b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.2__lodash@4_64be4d9407eb667fe9a1e2476327747d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90083b",
  null
  
)

export default component.exports